export default __webpack_public_path__ + "static/media/School Program - Class 8.4d1cdcc5.jpg";